import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import { appVersionScrollPadding } from "../../components/AppVersion/AppVersion";

const BaseLayout = ({ children }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flex: 1,
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            flex: 1,
            overflow: "auto",
            pb: appVersionScrollPadding,
          }}
        >
          {children || <Outlet />}
        </Box>
      </Box>
    </Box>
  );
};

export default BaseLayout;
